<form [formGroup]="step3Form" *ngIf="showView">
  <div class="step3-inner">
    <div class="row">
      <div class="col-md-6" *ngIf="isRegUrlAllowed">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Registration Link URL</mat-label>
            <input matInput type="text" placeholder="Enter URL e.g. http://www.example.com"
              formControlName="registrationLinkUrl" />
          </mat-form-field>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.registrationLinkUrl">
          </control-messages>
        </div>
      </div>

      <div class="col-md-6" *ngIf="isCatalogUrlAllowed">
        <div class="form-group">
          <div class="input-with-tooltip">
            <mat-form-field appearance="outline">
              <mat-label>Catalog Link URL</mat-label>
              <input matInput type="text" placeholder="Enter URL e.g. http://www.example.com"
                formControlName="catalogLinkUrl" />
            </mat-form-field>
            <span class="custom-tooltip" #tooltip="matTooltip"
              matTooltip="The selected sale type uses Third Party Registration, please enter the link to register on the appropriate third party platform"
              [matTooltipPosition]="'above'">
              <img alt="info" src="../assets/images/info.svg" />
            </span>
          </div>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.catalogLinkUrl">
          </control-messages>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-textarea">
            <mat-form-field appearance="outline">
              <mat-label>Page Title</mat-label>
              <textarea matInput formControlName="pageTitle" placeholder="Enter Page Title"
                [maxlength]="fieldMaxLengthMedium">
              </textarea>
            </mat-form-field>
          </div>
          <char-counter [control]="step3Form.controls.pageTitle" [maxlength]="fieldMaxLengthMedium"></char-counter>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.pageTitle"></control-messages>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-textarea">
            <mat-form-field appearance="outline">
              <mat-label>Meta Description</mat-label>
              <textarea matInput formControlName="metaDescription" placeholder="Add Description"
                [maxlength]="fieldMaxLengthLong"></textarea>
            </mat-form-field>
          </div>
          <char-counter [control]="step3Form.controls.metaDescription" [maxlength]="fieldMaxLengthLong"></char-counter>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.metaDescription">
          </control-messages>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group with-chips form-group-adj-label">
          <mat-form-field appearance="outline">
            <mat-label>Keywords</mat-label>
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let key of keywords" [selectable]="selectable" [removable]="removable"
                (removed)="removeKeyword(key)">
                {{ key }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input type="text" placeholder="Add Keywords" [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="addKeyword($event)" />
            </mat-chip-list>
          </mat-form-field>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.keywords"></control-messages>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group form-group-adj-label">
          <div class="custom-select-option select-with-label input-with-tooltip select-with-checks">
            <mat-form-field appearance="outline">
              <mat-label>Related Auctions (Select one or more)</mat-label>
              <mat-select formControlName="relatedAuctionIds" multiple>
                <mat-option *ngFor="let auction of upcomingAuctionList" [value]="auction.value">{{ auction.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="This is upcoming auctions"
              [matTooltipPosition]="'above'">
              <img alt="info" src="../assets/images/info.svg" />
            </span>
          </div>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.relatedAuctionIds">
          </control-messages>
        </div>
      </div>

      <div class="col-md-6" *ngIf="isShowEmailTemplates">
        <div class="form-group form-group-adj-label">
          <div class="custom-select-option select-with-label">
            <mat-form-field appearance="outline">
              <mat-label>Pre Approval Registration Email Template *</mat-label>
              <mat-select formControlName="preApprovalRegistrationEmailTemplateId">
                <mat-option *ngFor="let temp of prePostTemplateList" [value]="temp.value">{{ temp.text }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <control-messages [isFormSubmitted]="submitted" [control]="
              step3Form.controls.preApprovalRegistrationEmailTemplateId
            "></control-messages>
        </div>
      </div>

      <div class="col-md-6" *ngIf="isShowEmailTemplates">
        <div class="form-group form-group-adj-label">
          <div class="custom-select-option select-with-label">
            <mat-form-field appearance="outline">
              <mat-label>Post Approval Registration Email Template *</mat-label>
              <mat-select formControlName="postApprovalRegistrationEmailTemplateId">
                <mat-option *ngFor="let temp of prePostTemplateList" [value]="temp.value">{{ temp.text }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <control-messages [isFormSubmitted]="submitted" [control]="
              step3Form.controls.postApprovalRegistrationEmailTemplateId
            "></control-messages>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-textarea">
            <mat-form-field appearance="outline">
              <mat-label>Email Notes</mat-label>
              <textarea matInput formControlName="emailNotes" placeholder="Add Notes"
                [maxlength]="fieldMaxLength1000"></textarea>
            </mat-form-field>
          </div>
          <char-counter [control]="step3Form.controls.emailNotes" [maxlength]="fieldMaxLength1000"></char-counter>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.emailNotes"></control-messages>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h3 class="form-two-hdg pt-3">Removal Documents</h3>
        <p class="form-two-des mb-2">
          These documents will be published on the sale detail page.
        </p>
      </div>

      <div class="col-12">
        <div class="add-doc-outer" formArrayName="documents">
          <div class="add-doc" *ngFor="let doc of documents().controls; let pointIndex = index"
            [formGroupName]="pointIndex">
            <div class="doc-left">
              <div class="form-group m-0">
                <mat-form-field appearance="outline">
                  <mat-label>Add Document Name</mat-label>
                  <input matInput type="text" formControlName="fileTitle" placeholder="Enter name"
                    [maxlength]="fieldMaxLengthShorter" required />
                </mat-form-field>
                <char-counter [control]="eachDocumentControl(doc).fileTitle" [maxlength]="fieldMaxLengthShorter">
                </char-counter>
                <control-messages [isFormSubmitted]="submitted" [control]="eachDocumentControl(doc).fileTitle">
                </control-messages>
              </div>
            </div>

            <div class="doc-right">
              <h3 class="doc-hdg">Upload File *</h3>
              <div class="doc-upload">
                <button class="btn btn-colored browse-btn" role="button" (click)="document.click()">
                  <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Create_New_Auction_Display_Details" transform="translate(-608.000000, -975.000000)"
                        fill="#F7F7F7">
                        <g id="Group-4" transform="translate(607.000000, 974.000000)">
                          <path
                            d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                            id="Combined-shape-1226"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  Browse
                </button>
                <input type="file" style="display: none" [accept]="documentFormat" #document
                  (change)="attachDocument(doc, $event.target.files[0])" />
                <span class="doc-name">
                  <span *ngIf="eachDocumentFileNameisString(doc); else uploadedFile">
                    <a target="_blank" [href]="eachDocumentControl(doc).file.value">uploaded file
                    </a>
                  </span>
                  <ng-template #uploadedFile>
                    <span>
                      {{
                      eachDocumentControl(doc).file.value
                      ? eachDocumentControl(doc).file.value.name
                      : "No File Chosen"
                      }}
                    </span>
                  </ng-template>
                  <img alt="cross" class="cursor-pointer" role="button" (click)="deleteDocument(pointIndex, doc)"
                    src="../assets/images/cross.svg" />
                </span>
              </div>
              <control-messages [isFormSubmitted]="submitted" [control]="eachDocumentControl(doc).file">
              </control-messages>
            </div>
          </div>
        </div>
        <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.documents"></control-messages>
        <div>
          <span class="add-another-outer" role="button" (click)="addDocument()">
            <span class="add-another">
              <img alt="plus-icon" src="../assets/images/plus-icon.svg" />
              {{ documentString }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h3 class="form-two-hdg pt-3">Payment Documents</h3>
        <p class="form-two-des mb-2">
          These documents will be published on the sale detail page.
        </p>
      </div>
      <div class="col-12">
        <div class="add-doc-outer" formArrayName="paymentDocuments">
          <div class="add-doc" *ngFor="let doc of documents(true).controls; let pointIndex = index"
            [formGroupName]="pointIndex">
            <div class="doc-left">
              <div class="form-group m-0">
                <mat-form-field appearance="outline">
                  <mat-label>Add Document Name</mat-label>
                  <input matInput type="text" formControlName="fileTitle" [maxlength]="fieldMaxLengthShorter"
                    placeholder="Enter name" />
                </mat-form-field>
                <char-counter [control]="eachDocumentControl(doc).fileTitle" [maxlength]="fieldMaxLengthShorter">
                </char-counter>
                <control-messages [isFormSubmitted]="submitted" [control]="eachDocumentControl(doc).fileTitle">
                </control-messages>
              </div>
            </div>
            <div class="doc-right">
              <h3 class="doc-hdg">Upload File</h3>
              <div class="doc-upload">
                <button class="btn btn-colored browse-btn" role="button" (click)="payDocument.click()">
                  <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Create_New_Auction_Display_Details" transform="translate(-608.000000, -975.000000)"
                        fill="#F7F7F7">
                        <g id="Group-4" transform="translate(607.000000, 974.000000)">
                          <path
                            d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                            id="Combined-shape-1226"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  Browse
                </button>
                <input type="file" style="display: none" [accept]="documentFormat" #payDocument
                  (change)="attachDocument(doc, $event.target.files[0])" />
                <span class="doc-name">
                  <span *ngIf="eachDocumentFileNameisString(doc); else uploadedFile">
                    <a target="_blank" [href]="eachDocumentControl(doc).file.value">uploaded file
                    </a>
                  </span>
                  <ng-template #uploadedFile>
                    <span>
                      {{
                      eachDocumentControl(doc).file.value
                      ? eachDocumentControl(doc).file.value.name
                      : "No File Chosen"
                      }}
                    </span>
                  </ng-template>
                  <img alt="cross" class="cursor-pointer" role="button" (click)="deleteDocument(pointIndex, doc, true)"
                    src="../assets/images/cross.svg" />
                </span>
              </div>
              <control-messages [isFormSubmitted]="submitted" [control]="eachDocumentControl(doc).file">
              </control-messages>
            </div>
          </div>
        </div>
        <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.paymentDocuments">
        </control-messages>
        <div>
          <span class="add-another-outer" role="button" (click)="addDocument(true)">
            <span class="add-another">
              <img alt="plus" src="../assets/images/plus-icon.svg" />
              {{ payDocumentString }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h3 class="form-two-hdg pt-4 mt-3">In Conjuction With</h3>
        <p class="form-two-des mb-4">Upload your partner logos</p>
      </div>

      <div class="col-12">
        <div class="max-width-600">
          <div ngfDrop multiple="1" selectable="1" [(validDrag)]="validComboDrag" [(files)]="partnerLogoArray"
            [accept]="logoFormat" [maxSize]="logoSize" [(lastInvalids)]="lastInvalids"
            class="well my-drop-zone custom-drop-zone" [class.invalid-drag]="validComboDrag === false"
            [class.valid-drag]="validComboDrag" [fileDropDisabled]="fileDropDisabled">
            <img alt="drag" src="../assets/images/drag-upload-thumb.png" />
            <p class="drag-name">
              Drag & Drop Your Images Here
              <br />
              <span>Or</span>
            </p>
            <div class="for-btn">
              <span>Upload Image</span>
            </div>
          </div>
          <div class="for-preview-images">
            <div class="image-zone-outer" *ngFor="let item of addEditPartnerLogo; let i = index">
              <div class="image-zone-inner">
                <div>
                  <img alt="prev-icon" class="previewIcon" [src]="item.name" />
                </div>
                <span class="cross-icon" role="button" (click)="removeOldImage(item)">
                  <img alt="cross-icon" src="../assets/images/black-cross.svg" />
                </span>
              </div>
            </div>
            <div class="image-zone-outer mb-3" *ngFor="let item of partnerLogoArray; let i = index">
              <div class="image-zone-inner">
                <div>
                  <div class="previewIcon" [ngfBackground]="item"></div>
                </div>
                <span class="cross-icon" role="button" (click)="removeLogo(i)">
                  <img alt="cross-icon" src="../assets/images/black-cross.svg" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="max-width-600 text-center">
        <p class="or-text">Or</p>
      </div>
      <div class="max-width-600 text-center">
        <button class="btn btn-colored mb-2" role="button" (click)="SyncPartnerLogoImages()">
          Sync Images
        </button>
      </div>
      <p class="upload-note m-0 pb-2">
        Note : Click "Sync Images" button to sync images placed on server.
      </p>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="mat-field-width mb-3">
          <p class="small-label mb-2">Payment Instructions *</p>
          <editor [initialValue]="paymentInstructionEditorString" (editorData)="
              editorContent($event, step3Form.controls.paymentInstructions)
            "></editor>
          <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.paymentInstructions">
          </control-messages>

        </div>
      </div>

      <div class="col-12">
        <div class="mat-field-width">
          <div class="form-group">
            <div class="custom-textarea">
              <ng-container *ngIf="showBPasEditor; else gBpEditor">
                <span>General Buyer's Premium *</span>
                <editor [initialValue]="gBpText" (editorData)="
                    editorContent(
                      $event,
                      step3Form.controls.generalBuyerPremium,
                      true
                    )
                  " [characterLimit]="premiumMaxLength"></editor>
              </ng-container>
              <ng-template #gBpEditor>
                <mat-form-field appearance="outline">
                  <mat-label>General Buyer's Premium *</mat-label>
                  <input matInput type="number" formControlName="gBP" />
                </mat-form-field>
              </ng-template>
            </div>
            <control-messages *ngIf="showBPasEditor" [isFormSubmitted]="submitted"
              [control]="step3Form.controls.generalBuyerPremium"></control-messages>
            <control-messages *ngIf="!showBPasEditor" [isFormSubmitted]="submitted" [control]="step3Form.controls.gBP">
            </control-messages>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="mat-field-width">
          <div class="form-group">
            <div class="custom-textarea input-with-tooltip">
              <ng-container *ngIf="!showBPasEditor">
                <mat-form-field appearance="outline">
                  <mat-label>Credit Card Buyer's Premium </mat-label>
                  <input matInput type="number" formControlName="ccBP" />
                </mat-form-field>
              </ng-container>
              <span class="custom-tooltip" #tooltip="matTooltip"
                matTooltip="Enter a number for Credit Card Buyers Premium percentage, or 0 if Credit Cards are not accepted."
                [matTooltipPosition]="'above'">
                <img alt="info" src="../assets/images/info.svg" />
              </span>
            </div>
            <control-messages *ngIf="showBPasEditor" [isFormSubmitted]="submitted"
              [control]="step3Form.controls.creditCardBuyerPremium"></control-messages>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="showFeaturedItemsHeader">
        <div class="mat-field-width pt-3">
          <div class="form-group">
            <div class="input-with-tooltip">
              <mat-form-field appearance="outline">
                <mat-label>Featured Items Header</mat-label>
                <input matInput type="text" formControlName="featuredItemHeader" placeholder="Enter here"
                  [maxlength]="fieldMaxLength" />
              </mat-form-field>
              <span class="custom-tooltip" #tooltip="matTooltip"
                matTooltip="Enter alternate header for Featured Items section" [matTooltipPosition]="'above'">
                <img alt="info" src="../assets/images/info.svg" />
              </span>
            </div>
            <char-counter [control]="step3Form.controls.featuredItemHeader" [maxlength]="fieldMaxLength"></char-counter>
            <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.featuredItemHeader">
            </control-messages>
          </div>
        </div>
      </div>

      <div class="col-12">
        <p class="small-label mb-2">Featured Items</p>
        <div *ngIf="showForm">
          <editor [initialValue]="featuredItemsText" (editorData)="
              editorContent($event, step3Form.controls.featuredItems)
            " [characterLimit]="fieldMaxLengthTenThousand"></editor>
        </div>
        <control-messages [isFormSubmitted]="submitted" [control]="step3Form.controls.featuredItems"></control-messages>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h3 class="form-two-hdg pt-4 mt-3">Custom Buttons</h3>
        <p class="form-two-des mb-3 pb-1">
          Add your own buttons and link them to URL's or files
        </p>
      </div>
      <div class="col-12">
        <div class="add-btns-outer" formArrayName="buttons">
          <div class="add-btns-row" *ngFor="let btn of buttons().controls; index as idx" [formGroupName]="idx">
            <div class="add-image">
              <p class="btns-hdg">Button Logo/Image *</p>
              <div class="">
                <span *ngIf="btn.value.buttonName != null">
                  <img alt="btn-icon" class="mb-2" [src]="btn.value.buttonName" width="50" />
                  {{
                  btn.value.buttonName.split("/")[
                  btn.value.buttonName.split("/").length - 1
                  ] | characterLimit: 10
                  }}
                </span>
                <button class="btn btn-colored select-btn" role="button"
                  (click)="openModalImageButtonSelect(template, btn)">
                  Select Image
                </button>
              </div>
              <control-messages [isFormSubmitted]="submitted" [control]="eachButtonControl(btn).buttonName">
              </control-messages>
            </div>

            <div class="btn-label-input">
              <div class="form-group m-0">
                <mat-form-field appearance="outline">
                  <mat-label>Button Label *</mat-label>
                  <input matInput type="text" [maxlength]="fieldMaxLength" formControlName="label"
                    placeholder="Enter Label" />
                </mat-form-field>
                <char-counter [control]="eachButtonControl(btn).label" [maxlength]="fieldMaxLength"></char-counter>
                <control-messages [isFormSubmitted]="submitted" [control]="eachButtonControl(btn).label">
                </control-messages>
              </div>
            </div>

            <div class="radio-wrap">
              <p class="btns-hdg mb-2">Button Type</p>
              <div class="for-radio-select">
                <div class="d-flex">
                  <div class="form-group custom-radio radio-dark mr-4 pr-1 mb-0">
                    <input type="radio" id="url" [value]="true" formControlName="isUrl" selected
                      (change)="changeButtonType(eachButtonControl(btn))" />
                    <label for="url" class="m-0">URL</label>
                  </div>
                  <div class="form-group custom-radio radio-dark mr-4 pr-2 mb-0">
                    <input id="file-upload" type="radio" [value]="false" formControlName="isUrl"
                      (change)="changeButtonType(eachButtonControl(btn))" />
                    <label for="file-upload" class="m-0">File Upload</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="upload-wrap" *ngIf="btn.value.isUrl; else fileUploadTemplate">
              <div class="upload-wrap-inner">
                <div class="form-group m-0">
                  <mat-form-field appearance="outline">
                    <mat-label>URL</mat-label>
                    <input matInput type="text" formControlName="url"
                      placeholder="Enter URL e.g. http://www.example.com" required />
                  </mat-form-field>
                  <control-messages [isFormSubmitted]="submitted" [control]="eachButtonControl(btn).url">
                  </control-messages>
                </div>
              </div>
            </div>
            <ng-template #fileUploadTemplate>
              <div class="upload-wrap">
                <p class="btns-hdg">Upload File *</p>
                <div class="upload-wrap-inner">
                  <button class="btn btn-colored browse-btn" role="button" (click)="buttons.click()">
                    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Create_New_Auction_Display_Details" transform="translate(-608.000000, -975.000000)"
                          fill="#F7F7F7">
                          <g id="Group-4" transform="translate(607.000000, 974.000000)">
                            <path
                              d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                              id="Combined-shape-1226"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    Browse
                  </button>
                  <input type="file" class="d-none" [accept]="documentFormat" #buttons
                    (change)="attachButtonFile(btn, $event.target.files[0])" />
                  <span class="file-name">
                    <span *ngIf="eachButtonFileNameisString(btn); else uploadedFile">
                      <a target="_blank" [href]="eachButtonControl(btn).auctionFileName.value">uploaded file
                      </a>
                    </span>
                    <ng-template #uploadedFile>
                      <span>
                        {{
                        eachButtonControl(btn).auctionFileName.value
                        ? eachButtonControl(btn).auctionFileName.value.name
                        : "No File Chosen"
                        }}
                      </span>
                    </ng-template>
                  </span>
                </div>
                <control-messages [isFormSubmitted]="submitted" [control]="eachButtonControl(btn).auctionFileName">
                </control-messages>
              </div>
            </ng-template>
            <div class="delete-wrap" role="button" (click)="deleteButton(idx, btn)">
              <img alt="delete-icon" src="../assets/images/delete.svg" />
            </div>
          </div>
        </div>
        <div class="add-another-outer pt-2 mb-2">
          <span class="add-another" role="button" (click)="addButton()">
            <img alt="plus-icon" src="../assets/images/plus-icon.svg" />
            {{ customButtonString }}
          </span>
        </div>
      </div>

      <div *ngIf="step3Form.invalid && submitted" class="error-msg my-2">
        Please resolve error(s) first
      </div>

      <div class="col-12">
        <div class="steps-btn-wrap pt-4 mt-2">
          <button class="btn btn-white-border mr-2 half-mob" role="button" (click)="onCancel()">
            Cancel
          </button>
          <button class="btn btn-white-border mr-2 half-mob" role="button" (click)="goToStep()">
            Back
          </button>
          <button type="submit" class="btn btn-colored full-mob" role="button" (click)="onSaveAndContinue()"
            [disabled]="loading || checkLoader$.value">
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image For Custom Button</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <p class="sm-des">Select a thumbnail image for your button</p>
    <form (ngSubmit)="setButtonName(form)" #form="ngForm">
      <ul class="image-listing">
        <li *ngFor="let btn of customButtons; index as idx; count as length"
          [ngClass]="{ active: btn == form.value.customButton }">
          <img alt="icon" class="image-icon" [src]="btn" width="36" />
          <label [for]="idx" class="m-0 w-100">
            <span class="for-dtl">
              {{ btn.split("/")[btn.split("/").length - 1] }}
              <img alt="check-icon" class="check-icon" src="../assets/images/check-green2.svg" />
            </span>
          </label>
          <input name="customButton" ngModel type="radio" [value]="btn" [id]="idx" required />
        </li>
      </ul>
      <div class="image-popup-wrap pt-4 mt-2">
        <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-colored" [disabled]="form.invalid">
          Done
        </button>
      </div>
    </form>
  </div>
</ng-template>
